import { styled, Box, Button, CircularProgress, InputBase } from "@mui/material"

export const Dropzone = styled(Box)(({ theme }) => ({
  minHeight: "170px",
  background: "rgba(139,195,74,0.2)",
  borderRadius: "5px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "20px",
  padding: "15px 10px",
  cursor: "pointer",
  width: "100%",
  border: "2px dashed #8bc34a",
  outline: "none",
  textAlign: "center",
  marginBottom: "15px",
  color: "#a7b1eb",
  transition: "background 0.2s",
  "& p": {
    fontWeight: "bold",
  },
}))

export const DragActive = styled(Box)(({ theme }) => ({
  background: "rgba(167, 177, 235, 0.4)",
}))

export const DragAccept = styled(Box)(({ theme }) => ({
  background: "rgba(139, 195, 74, 0.4)",
}))

export const DragReject = styled(Box)(({ theme }) => ({
  color: "rgba(255, 0, 0, 0.4)",
  border: "2px dashed rgba(255, 0, 0, 0.4)",
}))

export const UploadButton = styled(Button)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#8bc34a",
  color: "#fff",
  padding: "10px",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#7ab633",
    boxShadow: "none",
  },
}))

export const CloseButton = styled(Button)(({ theme }) => ({
  background: "#f1f1f5",
  position: "absolute",
  top: 8,
  right: 8,
  width: 25,
  height: 25,
}))

export const Progress = styled(CircularProgress)(({ theme }) => ({
  margin: "25px 0 20px",
}))

export const Datepicker = styled(InputBase)(({ theme }) => ({
  width: "100%",
  padding: "19.5px 14px",
  borderRadius: "4px",
  background: "transparent",
  border: "1px solid #c0c0c0",
  position: "relative",
  zIndex: 1,
  outline: "none",
  "&:hover": {
    border: "1px solid #000",
    cursor: "pointer",
  },
  "&:focus": {
    border: "1px solid #8bc34a",
  },
}))

export const CalendarIcon = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "45%",
  right: "10%",
  transform: "translateY(-50%)",
}))
